import { activityCategories } from "../../data/activities";
import NavBar from "../NavBar.js";

function QuizForm({
  personNumber,
  selectedActivities,
  onSelectionChange,
  onComplete,
}) {
  const toggleActivity = (activityId) => {
    if (selectedActivities.includes(activityId)) {
      onSelectionChange(selectedActivities.filter((id) => id !== activityId));
    } else {
      onSelectionChange([...selectedActivities, activityId]);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <NavBar></NavBar>
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div>
          <div className="px-8 py-10">
            {/* Person Indicator */}
            <div className="bg-blue-50 rounded-lg p-6 mb-8 text-center border border-blue-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Person {personNumber}'s Turn
              </h2>
              <p className="text-gray-700">
                Check any activities you're interested in or open to trying. Be
                honest — there are no right or wrong answers.
              </p>
            </div>

            {/* Privacy reminder */}
            <div className="flex items-center justify-center gap-2 mb-8">
              <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full border border-blue-200 text-xs">
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
                <span className="font-medium">Private - Nothing saved</span>
              </div>
            </div>

            {/* Categories */}
            {activityCategories.map((category) => (
              <div key={category.id} className="mb-10">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                  {category.name}
                </h3>
                <div className="space-y-2">
                  {category.activities.map((activity) => (
                    <label
                      key={activity.id}
                      className="flex items-center gap-3 p-3.5 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors border border-transparent hover:border-gray-200"
                      onClick={() => toggleActivity(activity.id)}
                    >
                      <div
                        className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all flex-shrink-0 ${
                          selectedActivities.includes(activity.id)
                            ? "bg-green-500 border-green-500"
                            : "border-gray-300"
                        }`}
                      >
                        {selectedActivities.includes(activity.id) && (
                          <svg
                            className="w-3.5 h-3.5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={3}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        )}
                      </div>
                      <span className="text-gray-800">{activity.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            {/* Bottom Button */}
            <div className="pt-6 border-t border-gray-200">
              <button
                onClick={onComplete}
                className="w-full bg-green-500 text-white py-4 rounded-lg text-lg font-semibold hover:bg-green-400 transition-colors shadow-sm"
              >
                I'm Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizForm;
